import { FC, ReactNode } from 'react'

interface CenterProps {
  children: ReactNode
}

const Center: FC<CenterProps> = ({ children }) => (
  <div className="w-full h-full flex justify-center items-center">{children}</div>
)

export default Center
